export default "__VITE_ASSET__d21d10ce__"